import { waitForElementToExist } from './waitForElement';
import { callOutsStyle } from './callOut';
import { textureCart } from '../components/textureCart';

/* eslint-disable */
const pageStyle = ({ page }) => {
	const container = page.querySelector('.c7-wrapper');
	if (!container) return;
	const parent = page.parentElement;
	page.classList += ` bg-transparent`;

	parent.style.position = 'relative';
	parent.style.overflow = 'auto';

	container.classList = `page-container flex flex-col xl:flex-row gap-4`;
	const main = container.closest('main');
	const bgImage = document.createElement('img')
	/* image background */
	bgImage.src = template.texture_default;
	bgImage.classList = 'absolute inset-0 object-cover object-top w-full h-full mix-blend-multiply opacity-20'
	main.classList += ' relative bg-[#FBF9F0] pb-12'
	main.appendChild(bgImage)

	const checkoutMain = page.querySelector('.c7-checkout__main')
	checkoutMain.querySelectorAll('.c7-checkout__header, .c7-checkout__footer, main').forEach(element => {
		element.classList += ' bg-primary'
		if (element.classList.contains('c7-checkout__footer')) {
			element.classList += ' mt-6 border-l-2 border-yellow py-6 px-8 [&_a]:text-sm [&_a]:font-semibold'
			const terms = element.querySelector('a[href="/terms"]');
			terms && (terms.innerHTML = 'Terms & policies');
		}
		else if (element.classList.contains('c7-checkout__header')) {
			element.classList += ' px-8 pt-6'
		}
	})
	checkoutMain.querySelector('main').classList += ' min-h-0 px-8 py-6'
	const logos = page.querySelectorAll('.c7-checkout-logo')
	logos.forEach(logo => {
		logo.parentElement.style.display = 'none'
	})

	const sidebar = page.querySelector('.c7-checkout__summary-container')
	sidebar.style.backgroundColor = 'var(--primary-color)'
	sidebar.style.minHeight = 'initial'
	sidebar.style.padding = '0'
}
const titleFormStyle = ({ selector, form }) => {
	if ((form && !form.querySelector('.c7-h1')) || !form) {
		selector.style.display = 'none';
		return;
	}
	const className = 'mb-8 text-xl font-bold uppercase headlines-font lg:text-2xl text-brown';
	selector && (selector.outerHTML = `<h2 class="${className}">${form.classList.contains('c7-form--login') ? 'Lo gin' : 'Check out as guest'}</h2>`);
}
const titleStyle = ({ page }) => {
	/* title */
	page.parentElement.insertAdjacentHTML('afterbegin', `<h1 class="text-2xl font-bold uppercase headlines-font md:text-3xl lg:text-4xl xl:text-5xl text-center headline-title gap-4 text-brown mb-8 mt-12">Checkout</h1>`);
}
const breadcrumbStyle = ({ page, reset = false }) => {
	const breadcrumbs = page.querySelector('.c7-breadcrumbs');
	if (!breadcrumbs) return;
	if (reset) {
		const breadcrumbsBase = page.querySelector('.breadcrumbs');
		breadcrumbsBase && breadcrumbsBase.remove();
	}

	const breadcrumbsBase = breadcrumbs.cloneNode(true);

	breadcrumbs.style.display = 'none';

	breadcrumbsBase.classList = 'breadcrumbs flex justify-between items-center text-brown uppercase font-bold text-sm pb-6 border-b border-[#EAEAEA]';
	const breadcrumbsOl = breadcrumbsBase.querySelector('ol');
	const breadcrumbsLi = breadcrumbsOl.querySelectorAll('li');
	breadcrumbsOl.classList = `grid ${breadcrumbsLi.length > 3 ? 'grid-cols-4' : 'grid-cols-3'} gap-4 items-center [&_li:not(.c7-active,.c7-completed)]:opacity-60`;

	const activeItem = breadcrumbsOl.querySelector('.c7-active');
	if (activeItem) {
		const innerHTML = activeItem.querySelector('a').innerHTML;
		const count = activeItem.querySelector('.c7-step-count');
		activeItem.querySelector('a').style.display = 'none';
		activeItem.insertAdjacentHTML('afterbegin', `${innerHTML}`);
		// remove from activeItem the c7stepcount
		const countText = count.textContent.replace('.', '');
		const h2 = document.createElement('h2');
		h2.classList = 'text-2xl lg:text-4xl text-brown font-bold uppercase headlines-font text-center gap-4';
		h2.innerHTML = `<span class="mr-2 text-yellow">0${countText}</span><span class="title-checkout">${innerHTML}</span>`;
		h2.querySelector('.c7-step-count').style.display = 'none';
		const titleCheckout = h2.querySelector('.title-checkout');
		const titleCheckoutText = titleCheckout.textContent;
		const titleCheckoutTextArray = titleCheckoutText.split('.');
		activeItem.dataset.icon = titleCheckoutTextArray.pop().trim().toLowerCase();
		breadcrumbsBase.insertAdjacentElement('afterbegin', h2);
	}

	const liContent = [];
	breadcrumbsLi.forEach(li => {
		li.querySelector('.c7-step-count').style.display = 'none';
		liContent.push(li.cloneNode(true));
		if (li.classList.contains('c7-active')) {
			import("../components/iconsCheckout").then(({ iconCheckoutActive }) => {
				li.innerHTML = `<div class="flex flex-col items-center relative mr-2"><span class="w-10 h-10 rounded-full border-2 border-yellow grid place-items-center">${iconCheckoutActive({ icon: li.dataset.icon, props: 'style="width: 1rem; height: 1rem; stroke: none; stroke-width: 0;"' })}</span></div>`;
			})
		} else if (li.classList.contains('c7-completed')) {
			const linkCompletedItem = li.querySelector('a').getAttribute('href');
			li.innerHTML = `<a href="${linkCompletedItem}" class="group/item flex flex-col items-center relative mr-2"><span class="group-hover/item:shadow-md group-hover/item:shadow-brown transition w-8 h-8 rounded-full border-2 border-yellow bg-yellow grid place-items-center relative before:h-[2px] before:w-7 before:absolute before:right-0 before:bg-[var(--before-color)] before:translate-x-full before:top-1/2 before:-mr-2.5" style="--before-color: var(--yellow)"><svg style="width: .75rem; height: .75rem; stroke: none; stroke-width: 0;" xmlns="http://www.w3.org/2000/svg" width="13" height="10" viewBox="0 0 13 10">
  			<path id="check" d="M14.767,5.225,7.333,13.143l-3.1-3.3a.691.691,0,0,0-1.021,0,.8.8,0,0,0,0,1.088l3.611,3.846a.691.691,0,0,0,1.021,0l7.944-8.462a.8.8,0,0,0,0-1.088.691.691,0,0,0-1.021,0Z" transform="translate(-3 -5)" fill="#fff"/></svg></span></a>`
		} else {
			li.innerHTML = `<div class="flex flex-col items-center relative before:h-[2px] before:w-8 before:absolute before:left-0 before:bg-[var(--before-color)] before:-translate-x-full before:top-1/2 before:ml-2" style="--before-color: #EAEAEA"><span class="w-6 h-6 rounded-full border-2 border-[#AAAE9D] block"></span></div>`;
		}
	})
	const breadcrumbsOlNew = document.createElement('ol');
	breadcrumbsOlNew.classList = `grid ${breadcrumbsLi.length > 3 ? 'grid-cols-4' : 'grid-cols-3'} gap-4 items-center [&_li:not(.c7-active,.c7-completed)]:opacity-60 text-xs [&_li:is(.c7-active,.c7-completed)]:mr-2`;
	breadcrumbsOlNew.innerHTML = liContent.map(li => `<li ${li.classList.value ? `class="${li.classList.value}"` : ''}>${li.innerHTML}</li>`).join('');
	breadcrumbsBase.appendChild(breadcrumbsOlNew);

	const newBreadcrumbs = document.createElement('div');
	newBreadcrumbs.classList = 'flex flex-col gap-2';
	// inser this two elements in newBreadcrumbs
	const newBreadcrumbsElements = breadcrumbsBase.querySelectorAll('ol');
	newBreadcrumbsElements.forEach(element => {
		newBreadcrumbs.appendChild(element);
	})
	breadcrumbsBase.appendChild(newBreadcrumbs);

	breadcrumbsBase.removeAttribute('style');

	breadcrumbs.insertAdjacentElement('afterend', breadcrumbsBase);
}
const couponStyle = ({ target }) => {
	const couponArea = target.querySelector('.c7-form--coupon-code-container');
	if (!couponArea) return;
	const trigger = couponArea.querySelector('.c7-link');
	trigger.innerHTML = 'Do you have a coupon code?';
	trigger.classList = 'text-brown no-underline mb-4';

	const inputText = couponArea.querySelector('input[name="couponCode"]');
	inputText.style = 'border: 0; margin: 0; background: none; box-shadow: none;';
	inputText.classList = 'focus:outline-none focus:ring-0 focus:border-transparent';

	const inputGroup = couponArea.querySelector('.c7-form__group');
	inputGroup.style = '--c7-button-border-radius:25px;';
	inputGroup.classList = 'bg-[#F0EFE7] p-0.5 rounded-3xl flex [&_.c7-btn]:button [&_.c7-btn]:button-solid [&_.c7-btn]:bg-yellow [&_.c7-btn]:text-white [&_.c7-btn]:uppercase [&_.c7-btn]:font-bold [&_.c7-btn]:border-0 [&_.c7-btn]:hover:no-underline [&_.c7-btn]:hover:[color:#fff!important;] [&_.c7-btn]:hover:[text-decoration:none!important;] [&_.c7-btn]:px-5';
}
const itemsClubStyle = ({ items }) => {
	if (!items) return;
	items.forEach(item => {
		item.classList += ' mx-6 border-b border-[#EAEAEA] [&:last-child]:border-0 pb-6 [&:last-child]:pb-0';
		const icon = item.querySelector('img');
		icon && (icon.style.display = 'none');
		const text = item.querySelector('p');
		text && (text.classList += ' text-brown font-medium');
		import("../components/iconsClubWine").then(({ iconActive }) => {
			const iconAlt = icon.getAttribute('alt');
			const iconAltArray = iconAlt && iconAlt.split(' ');
			const iconAltText = iconAlt && iconAltArray[0].toLowerCase();
			item.insertAdjacentHTML('afterbegin', `<span class="mr-3 flex-[1_0_auto] w-14 h-14 rounded-full p-1 bg-[#FFE383] grid place-items-center self-start">${iconActive({ icon: iconAltText, props: 'style="width: 30px; height: 30px; stroke: none; stroke-width: 0;"' })}</span>`);
		})
	})
}
const clubSummaryStyle = ({ element }) => {
	if (!element) return;
	element.classList += ' pb-6';
	const container = element.parentElement;
	const titleHeader = container.querySelector('#c7-checkout__summary-container-label');
	titleHeader && (titleHeader.style.display = 'none');
	const title = element.querySelector('.c7-club-summary__title');
	title && (title.classList += ' text-xl lg:text-2xl font-bold uppercase headlines-font mx-6 pt-4 text-brown');
	const titleSpan = element.querySelector('.c7-club-summary__selection');
	titleSpan && (titleSpan.classList += ' text-brown font-semibold flex items-center gap-2 pb-3 border-b border-[#EAEAEA] mx-6');

	const items = element.querySelectorAll('.icon-text-group');
	items && itemsClubStyle({ items });

	const callOut = container.querySelector('.c7-callout')
	if (callOut) {
		callOut.style = '--c7-bg: #363535; margin-bottom: 0; margin-top: 3.5rem'
		callOut.classList += ' px-6 border-t-0 text-xl font-semibold relative mt-14 order-1 pb-6 text-primary';
		callOut.insertAdjacentHTML('beforeend', textureCart({ props: `class="absolute top-0 left-0 -translate-y-10 z-10" style="width: 100%; height: auto; stroke: none; stroke-width: 0;"` }));

		const title = callOut.querySelector('.c7-callout__title');
		title && (title.classList += ' mb-6 font-semibold');

		const details = callOut.querySelector('.c7-callout__details');
		details && (details.style = '--c7-font-size-sub: 1rem; --c7-body-text-color: #FFF;');
		const svgDetails = details && details.querySelectorAll('svg');
		svgDetails && svgDetails.forEach(svg => {
			svg.style.stroke = 'var(--primary-color)';
		})
	}
}
const orderSummaryStyle = ({ page }) => {
	const orderSummary = page.querySelector('.c7-checkout__summary-container') || page.querySelector('.c7-side-checkout__summary-container');
	if (!orderSummary) return;
	page.querySelector('.c7-checkout__header--mobile') && (page.querySelector('.c7-checkout__header--mobile').classList += ' bg-primary font-semibold');
	orderSummary.querySelector('.c7-order-items__title') && (orderSummary.querySelector('.c7-order-items__title').style.display = 'none');
	orderSummary.querySelector('h2.c7-sr-only') && (orderSummary.querySelector('h2.c7-sr-only').classList = 'text-xl lg:text-2xl text-brown font-bold uppercase headlines-font mx-6 pt-4 pb-3 border-b border-[#EAEAEA]')
	orderSummary.classList += ' bg-[#FFFDF5] pt-8 relative lg:ml-4 lg:self-start';

	const clubSummary = orderSummary.querySelector('.c7-club-summary');
	clubSummary && clubSummaryStyle({ element: clubSummary });
	if (clubSummary) return;

	const orderItems = orderSummary.querySelector('.c7-order-items');
	orderItems && (orderItems.classList += ' grid grid-cols-1 gap-4 [&_ul>li]:px-6');
	const itemsTitle = orderItems && orderItems.querySelectorAll('.c7-order-item__title')
	itemsTitle && itemsTitle.forEach(title => {
		title.classList += ' text-base font-bold text-brown uppercase headlines-font';
	})
	const itemsDescription = orderItems && orderItems.querySelectorAll('.c7-order-item__description')
	itemsDescription && itemsDescription.forEach(description => {
		description.classList += ' text-sm text-brown uppercase font-bold';
	})
	const itemsPricing = orderItems && orderItems.querySelectorAll('.c7-order-item__pricing')
	itemsPricing && itemsPricing.forEach(pricing => {
		pricing.classList += ' text-base text-brown uppercase font-bold monospace-font';
		pricing.style = '--c7-font-size-sub: 1rem';
		pricing.querySelector('.c7-order-item__total') && (pricing.querySelector('.c7-order-item__total').classList += ' text-xl');
	})

	const order = orderSummary.querySelector('.c7-order-summary')
	order && (order.classList = 'z-10 relative flex flex-col [&_>div]:px-6 [&_.c7-h2]:px-6 text-sm');

	const orderTotals = orderSummary.querySelectorAll('.c7-order-summary__item--total');
	const orderTotalsLast = orderTotals && orderTotals[orderTotals.length - 1];
	if (orderTotalsLast) {
		orderTotalsLast.classList += ' px-6 bg-[#363535] border-t-0 text-white text-xl font-semibold relative mt-14 order-1 pb-6';
		orderTotalsLast.insertAdjacentHTML('beforeend', textureCart({ props: `class="absolute top-0 left-0 -translate-y-10 -z-10" style="width: 100%; height: auto; stroke: none; stroke-width: 0;"` }));
	}

	const orderDiscount = orderSummary.querySelector('.c7-order-summary__discount');
	orderDiscount && (orderDiscount.classList += ' mt-3');
	orderDiscount && (orderDiscount.querySelector('svg').style.display = 'none');

	couponStyle({ target: orderSummary });
}

const c7LinkCheckout = ({ page }) => {
	const addLinks = page.querySelectorAll('.c7-link');
	if (addLinks) {
		for (const link of addLinks) {
			if (link.textContent.toLowerCase().includes('add') && !link.querySelector('span')) {
				link.classList += ' text-brown no-underline mb-4 uppercase text-sm font-semibold';
				link.insertAdjacentHTML('beforeend', `<span class="font-bold text-xl ml-2">+</span>`);
			} else if (link.textContent.toLowerCase().includes('edit') && link.querySelector('span')) {
				link.querySelector('.inline-block') && link.querySelector('.inline-block').remove();
				link.insertAdjacentHTML('beforeend', `<span class="ml-1 inline-block">
				<svg xmlns="http://www.w3.org/2000/svg" width="18.888" height="18.889" viewBox="0 0 18.888 18.889" style="width: 1rem; height: 1rem; stroke: none; stroke-width: 0;">
				<g id="Group_25573" data-name="Group 25573" transform="translate(0.9 0.9)">
					<path id="Union_10" data-name="Union 10" d="M3541.459-5162.515a2.612,2.612,0,0,1-2.608-2.61v-11.96a2.612,2.612,0,0,1,2.608-2.609h3.417a.9.9,0,0,1,.9.9.9.9,0,0,1-.9.9h-3.417a.81.81,0,0,0-.809.809v11.96a.81.81,0,0,0,.809.809h11.962a.81.81,0,0,0,.808-.809v-3.417a.9.9,0,0,1,.9-.9.9.9,0,0,1,.9.9v3.417a2.612,2.612,0,0,1-2.608,2.61Zm3.417-5.127a.9.9,0,0,1-.644-.271.9.9,0,0,1-.253-.689l.256-3.845a.894.894,0,0,1,.261-.576l8.117-8.117a.9.9,0,0,1,.636-.264.9.9,0,0,1,.637.264l3.588,3.589a.9.9,0,0,1,0,1.269l-8.117,8.2a.9.9,0,0,1-.6.267l-3.845.171Zm1.133-4.347-.168,2.5,2.489-.11,7.239-7.316-2.32-2.319Z" transform="translate(-3539.75 5180.504)" fill="#7b5d27"/>
				</g>
				</svg>
				</span>`);
			} else if (link.textContent.toLowerCase().includes('apply') && !link.querySelector('span')) {
				link.classList += ' text-brown no-underline mb-4 uppercase text-sm font-semibold text-left';
				link.textContent = link.textContent.replace('+ ', '');
				link.insertAdjacentHTML('beforeend', `<span class="ml-1 inline-block">
				<svg id="gift" xmlns="http://www.w3.org/2000/svg" width="19.5" height="19.5" viewBox="0 0 19.5 19.5" style="width: 1rem; height: 1rem; stroke: none; stroke-width: 0;">
				<path id="Path_22791" data-name="Path 22791" d="M496.66,5.035H494.7A2.944,2.944,0,0,0,492.215.5c-2.175,0-3.416,1.692-4.081,3.124C487.468,2.192,486.228.5,484.053.5a2.943,2.943,0,0,0-2.48,4.535h-1.964a1.225,1.225,0,0,0-1.224,1.224V9.706a1.225,1.225,0,0,0,1.224,1.224h.589v7.845A1.225,1.225,0,0,0,481.422,20h13.423a1.225,1.225,0,0,0,1.224-1.224V10.93h.59a1.225,1.225,0,0,0,1.224-1.224V6.259a1.225,1.225,0,0,0-1.224-1.224M492.215,1.86a1.587,1.587,0,1,1,0,3.174h-3.183c.4-1.167,1.347-3.174,3.183-3.174M482.931,4.57a1.587,1.587,0,0,1,1.122-2.709c1.836,0,2.785,2.007,3.183,3.174h-3.183a1.574,1.574,0,0,1-1.122-.465M479.745,6.4h7.709V9.57h-7.709Zm1.814,4.535h5.9V18.64h-5.9ZM494.71,18.64h-5.9V10.93h5.9Zm1.814-9.07h-7.709V6.4h7.709Z" transform="translate(-478.384 -0.5)" fill="#7b5d27"/>
				</svg>
				</span>`);
			}
		}
	}
}
const shippingStyle = async ({ page }) => {
	const titles = page.querySelectorAll('.c7-h2');
	if (titles) {
		for (const [index, title] of titles.entries()) {
			title.classList = 'c7-h2';
			if (title.closest('.c7-checkout__review-block')) return;

			title.classList += ' text-xl lg:text-2xl font-bold uppercase mx-6 pt-4 pb-3 border-b border-[#EAEAEA]';
			title.style = `--c7-heading-font-family: var(--headlines-font); --c7-heading-text-color: var(--brown)`
			title.querySelector('span') && title.querySelector('span').remove();
			title.insertAdjacentHTML('afterbegin', `<span class="mr-2">0${index + 1}</span>`);
		}
	}
	c7LinkCheckout({ page });
}
export const checkoutPage = async () => {
	/* Setting title for login/guest */
	waitForElementToExist({ selector: '#c7-checkout .c7-checkout__content' }).then(() => {
		const checkout7 = document.querySelector('#c7-checkout .c7-checkout__content');
		checkout7.classList += ' [&_.c7-form>p]:mb-6 [&_.c7-form>p]:text-base [&_.c7-form>p]:text-brown [&_.c7-form>p]:font-bold [&_.c7-form>p]:flex [&_.c7-form>p]:gap-4';
		const form = checkout7.querySelector('.c7-form');
		const titleH1 = checkout7.querySelector('.c7-h1');
		titleH1 && titleFormStyle({ selector: titleH1, form });

		const passwordReset = checkout7.querySelector('.c7-account-login__password-options a');
		passwordReset && (passwordReset.textContent = 'Forgot password');

		const observer = new MutationObserver((mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const form = checkout7.querySelector('.c7-form');
					const titleH1 = checkout7.querySelector('.c7-h1');
					titleH1 && titleFormStyle({ selector: titleH1, form });

					const passwordReset = checkout7.querySelector('.c7-account-login__password-options a');
					passwordReset && (passwordReset.textContent = 'Forgot password');
				}
			}
		});
		observer.observe(checkout7, { childList: true });
	})

	waitForElementToExist({ selector: '#c7-checkout .c7-form--shipping-address' }).then(() => {
		const checkout7 = document.querySelector('#c7-checkout .c7-checkout__content');
		c7LinkCheckout({ page: checkout7 });
	})

	waitForElementToExist({ selector: '#c7-content #c7-checkout' }).then(() => {
		const checkout7 = document.querySelector('.site-main #c7-content #c7-checkout');
		pageStyle({ page: checkout7 });
		titleStyle({ page: checkout7 });
		callOutsStyle({ page: checkout7 });
		breadcrumbStyle({ page: checkout7 })
		orderSummaryStyle({ page: checkout7 });
	})

	waitForElementToExist({ selector: '#c7-checkout #c7-delivery-shipping-group' }).then(() => {
		const checkout7 = document.querySelector('.site-main #c7-content #c7-checkout');
		breadcrumbStyle({ page: checkout7, reset: true });
		shippingStyle({ page: checkout7 }).then(() => {
			const observer = new MutationObserver((mutationsList, observer) => {
				for (const mutation of mutationsList) {
					if (mutation.type === 'childList') {
						shippingStyle({ page: checkout7 });
					}
				}
			});
			observer.observe(checkout7.querySelector('.c7-checkout__content'), { childList: true });
		})
	})

	waitForElementToExist({ selector: '#c7-checkout .c7-form--creditCard' }).then(() => {
		const checkout7 = document.querySelector('.site-main #c7-content #c7-checkout');
		breadcrumbStyle({ page: checkout7, reset: true });
		c7LinkCheckout({ page: checkout7 });
	})

	waitForElementToExist({ selector: '#c7-checkout .c7-checkout__review' }).then(() => {
		const checkout7 = document.querySelector('.site-main #c7-content #c7-checkout');
		breadcrumbStyle({ page: checkout7, reset: true });
		c7LinkCheckout({ page: checkout7 });

		const allEdit = checkout7.querySelectorAll('.c7-checkout__review-block');
		allEdit && allEdit.forEach(edit => {
			edit.querySelector('.c7-link') && edit.querySelector('.c7-link').remove();
		})
	})

	/* wine club products */
	waitForElementToExist({ selector: '#c7-checkout .c7-breadcrumbs' }).then(() => {
		const checkout7 = document.querySelector('.site-main #c7-content #c7-checkout');
		breadcrumbStyle({ page: checkout7, reset: true });
	})

	waitForElementToExist({ selector: '#c7-checkout .c7-club-products' }).then(() => {
		const checkout7 = document.querySelector('.site-main #c7-content #c7-checkout');
		breadcrumbStyle({ page: checkout7, reset: true });

		const products = checkout7.querySelectorAll('.c7-club-product');
		products && products.forEach(product => {
			const qtyContainer = product.querySelector('.c7-club-product__details__quantity');
			qtyContainer && (qtyContainer.classList += ' flex items-center gap-4');
			const buttons = qtyContainer.querySelectorAll('button');
			buttons && buttons.forEach(button => {
				button.classList = 'text-brown font-bold uppercase text-sm p-4';
			})
		})
	})

	waitForElementToExist({ selector: '.c7-modal .c7-club-summary__description' }).then(() => {
		const items = document.querySelectorAll('.c7-modal .c7-club-summary__description .icon-text-group');
		items && itemsClubStyle({ items });

		const observer = new MutationObserver((mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'childList') {
					const modal = document.querySelector('#c7-modal');
					if (!modal) return;
					const items = document.querySelectorAll('.c7-modal .c7-club-summary__description .icon-text-group');
					items && itemsClubStyle({ items });
				}
			}
		});
		observer.observe(document.querySelector('body'), { childList: true });
	})
}